import React from 'react';
import styled from 'styled-components';

import { List } from 'components/styled-primitives';

const CoAdminListStyled = styled(List)`
  max-height: 145px;
  margin-left: 30px;
`;

type ListItemValue = string | Record<string, React.ReactNode>;

interface CoAdminListProps {
  listRecords: ListItemValue[];
  onDelete: (item: string) => void;
}

const CoAdminList = ({ listRecords, onDelete }: CoAdminListProps): React.JSX.Element => {
  return (
    <CoAdminListStyled
      items={listRecords}
      labelField="primaryEmail"
      overflow="auto"
      onDelete={onDelete}
    />
  );
};

export default CoAdminList;
